// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const smsModalActions = require('client-v2/into-landing/containers/sms-modal/actions')
// Sibling imports
const Header = require('./component-dumb')

function mapStateToProps(state, ownProps) {
  return {
    // Flags
    isAndroid: state.env.browser.has('android'),
    isIos: state.env.browser.has('ios'),
    isDesktop: state.env.browser.has('isDesktop'),
    // Values
    assets: state.env.assets,
    deeplinkUrls: state.env.deeplinkUrls,
    user: state.user.loggedIn ? state.user : null,
    ...ownProps
  }
}

const mapDispatchToProps = {
  onLoginClick: authModalActions.showLogin,
  showSMSModal: smsModalActions.show
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    Header
  )
)
